import some from 'lodash/some'

export const ADD_NEW_SHIPPING_ADDRESS_ID = 'ADD_NEW_SHIPPING_ADDRESS_ID'

export const SHIPPING_ADDRESS_SUB_EVENT = {
  submit: 'shipping-address-submit',
  getAddress: 'get-current-shipping-address',
  validate: 'shipping-address-form-validation',
}

export const SHIPPING_ADDRESS_SUB_EVENT_ERROR_TYPE = {
  FORM_ERROR: 'FORM_ERROR',
  API_FAIL: 'API_FAIL',
  UNKNOWN: 'UNKNOWN',
}

export const isDefaultAddress = address => !!address.isDefault?.includes('true')

export const isValidAddressId = (addressId, addresses) => some(addresses, { shippingAddressId: addressId })

export const relocateAddressProperties = obj => {
  const { address, ...rest } = obj

  if (!address) return obj
  return { ...rest, ...address }
}

export const reverseRelocateAddressProperties = obj => {
  const {
    city, country, line1, line2, postalCode, stateProvince, ...rest
  } = obj
  const address = {}

  if (city !== undefined) address.city = city
  if (country !== undefined) address.country = country
  if (line1 !== undefined) address.line1 = line1
  if (line2 !== undefined) address.line2 = line2
  if (postalCode !== undefined) address.postalCode = postalCode
  if (stateProvince !== undefined) address.stateProvince = stateProvince

  return { ...rest, address }
}

export const convertAddressData = address => {
  const res = relocateAddressProperties(address)
  if (isDefaultAddress(res)) {
    return { ...res, isDefault: true }
  }
  return { ...res, isDefault: false }
}
export const reConvertAddressData = address => {
  const res = reverseRelocateAddressProperties(address)
  if (res.isDefault) {
    return { ...res, isDefault: ['true'] }
  }
  return { ...res, isDefault: [''] }
}
